import React from 'react';
import LogoutComponent from '../LogoutComponent/logoutComponent';
import style from './header.module.css';


const Header = () => {

  return (
    <div className={style.headerText}>
      <ul className={`${style.navRow} nav row`}>
        <li className="nav-item col">
        </li>
        <li className="nav-item col d-flex justify-content-center">
                    <span className={`${style.title} nav-link active`}>
            API PORTAL
          </span>
        </li>
        <li className="nav-item col d-flex justify-content-end align-items-center pr-3">
          <LogoutComponent />
        </li>
      </ul>

    </div>
  );
};

export default Header;
